import { CaseDocumentsRequest, DeleteDocumentRequest, UpdateImageRequest } from '../../details/shared/model';

import { UpdateDaccaCalculationRequest } from '../../details/dacca/model';
import api from './api';

const documentsUrl = '/documents';

export function getExpertiseAttachments(instructionId: number) {
  return api.get(`${documentsUrl}/cases/${instructionId}/expertise-attachments`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getImages(instructionId: number) {
  return api.get(`${documentsUrl}/cases/${instructionId}/images`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getOtherAttachments(instructionId: number) {
  return api.get(`${documentsUrl}/cases/${instructionId}/other-attachments`).catch(err => {
    console.error(err);
    return err;
  });
}

export function uploadImages(instructionId: number, request: CaseDocumentsRequest) {
  return api.post(`${documentsUrl}/cases/${instructionId}/images`, request).catch(err => {
    console.error(err);
    return err;
  });
}

export function uploadOtherAttachments(instructionId: number, request: CaseDocumentsRequest) {
  return api.post(`${documentsUrl}/cases/${instructionId}/other-attachments`, request).catch(err => {
    console.error(err);
    return err;
  });
}

export function deleteDocuments(request: DeleteDocumentRequest[]) {
  return api.post(`${documentsUrl}/delete`, request).catch(err => {
    console.error(err);
    return err;
  });
}

export function getCommentsOrReports(instructionId: number) {
  return api.get(`${documentsUrl}/cases/${instructionId}/comments-or-reports`).catch(err => {
    console.error(err);
    return err;
  });
}

export function uploadCommentOrReport(instructionId: number, request: CaseDocumentsRequest) {
  return api.post(`${documentsUrl}/cases/${instructionId}/comment-or-report`, request).catch(err => {
    console.error(err);
    return err;
  });
}

export function getDocumentTypes() {
  return api.get(`${documentsUrl}/cases/document-types`)
  .then((res) => {
    return res.data;
  })  
  .catch(err => {
    console.error(err);
    return err;
  });
}

export function updateImages(request: UpdateImageRequest[]) {
  return api.post(`${documentsUrl}/update/images`, request).catch(err => {
    console.error(err);
    return err;
  });
}

export function updateDaccaCalculation(caseCode: string, request: UpdateDaccaCalculationRequest) {
  return api.post(`${documentsUrl}/cases/${caseCode}/dacca-calculation`, request).catch(err => {
    console.error(err);
    return err;
  });
}
